<script lang="ts" setup>
// -------------------------------
// 🔹 Imports externes / composants
// -------------------------------
import type { IBaseButtonPrimaryProps } from '@/types/base_button_primary.types';
import BaseLoader from './BaseLoader.vue';

// -------------------------------
// 🔹 Refs globales
// -------------------------------
import { isLoaderLoginFormActivated } from '@/refs/login.form.refs';

// -------------------------------
// 🔹 Props
// -------------------------------
defineProps<IBaseButtonPrimaryProps>();

/**
 * Composant bouton principal réutilisable.
 * Affiche un loader lorsque `isLoaderLoginFormActivated` est true.
 * Utilise les props typées `IBaseButtonPrimaryProps`.
 */
</script>

<template>
  <button
    :type="type"
    :class="style_of_btn"
    class="text-16px font-tt-medium-Normal cursor-pointer leading-normal"
  >
    <span v-show="!isClicked">{{ label }}</span>
    <div v-show="isClicked" class="flex flex-row items-center gap-2">
      <BaseLoader />
      <span>{{ "En cours d'enregistrement..." }}</span>
    </div>
  </button>
</template>
